import { type FC, type RefObject } from 'react';

import { DesktopFilterMenu } from '$/components/core/Collection/CollectionFilter/components/DesktopFilterMenu';
import { MobileFilterDrawer } from '$/components/core/Collection/CollectionFilter/components/MobileFilter/MobileFilterDrawer';
import { useIsMobile } from '$/hooks/useIsMobile';

interface Props {
  sectionRef: RefObject<HTMLDivElement | null>;
  hideAmounts?: boolean;
  amount?: number;
}

export const CollectionFilter: FC<Props> = ({
  sectionRef,
  hideAmounts = false,
  amount,
}) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <MobileFilterDrawer amount={amount} />;
  }

  return (
    <DesktopFilterMenu sectionRef={sectionRef} hideAmounts={hideAmounts} />
  );
};
